var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_5982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.93457 5.93457 0.999999 12 1C18.0654 1 23 5.93457 23 12C23 18.0654 18.0654 23 12 23C5.93457 23 0.999999 18.0654 1 12ZM22.0547 12C22.0547 6.45583 17.5442 1.94531 12 1.94531C6.45583 1.94531 1.94531 6.45583 1.94531 12C1.94531 17.5442 6.45583 22.0547 12 22.0547C17.5442 22.0547 22.0547 17.5442 22.0547 12Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4531 7.05859C10.4531 6.20562 11.147 5.51172 12 5.51172C12.853 5.51172 13.5469 6.20562 13.5469 7.05859C13.5469 7.91157 12.8529 8.60547 12 8.60547C11.147 8.60547 10.4531 7.91157 10.4531 7.05859ZM12.6016 7.05859C12.6016 6.72688 12.3317 6.45703 12 6.45703C11.6683 6.45703 11.3984 6.72687 11.3984 7.05859C11.3984 7.39031 11.6683 7.66016 12 7.66016C12.3317 7.66016 12.6016 7.39031 12.6016 7.05859Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4531 12C10.4531 11.147 11.147 10.4531 12 10.4531C12.853 10.4531 13.5469 11.147 13.5469 12C13.5469 12.853 12.8529 13.5469 12 13.5469C11.147 13.5469 10.4531 12.853 10.4531 12ZM12.6016 12C12.6016 11.6683 12.3317 11.3984 12 11.3984C11.6683 11.3984 11.3984 11.6683 11.3984 12C11.3984 12.3317 11.6683 12.6016 12 12.6016C12.3317 12.6016 12.6016 12.3317 12.6016 12Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4531 16.9414C10.4531 16.0884 11.147 15.3945 12 15.3945C12.853 15.3945 13.5469 16.0884 13.5469 16.9414C13.5469 17.7944 12.8529 18.4883 12 18.4883C11.147 18.4883 10.4531 17.7944 10.4531 16.9414ZM12.6016 16.9414C12.6016 16.6097 12.3317 16.3398 12 16.3398C11.6683 16.3398 11.3984 16.6097 11.3984 16.9414C11.3984 17.2731 11.6683 17.543 12 17.543C12.3317 17.543 12.6016 17.2731 12.6016 16.9414Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_5982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(23 1) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/Options.00868eaa1388168cbd70a1e4baa322bb.svg";
export { ForwardRef as ReactComponent };